import { MessageCircle } from "lucide-react";
import { BUSINESS, SAMPLE_WHATSAPP_URL } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";
import { useEnquiry } from "@/context/EnquiryContext";
import { Reveal } from "@/components/Reveal";

const CREDENTIALS = [
  { label: "GST Registration", value: BUSINESS.gstin, note: "Registered in Telangana", testid: "credential-gstin" },
  { label: "FSSAI Licence", value: BUSINESS.fssai, note: "Food Business Operator licence", testid: "credential-fssai" },
  { label: "Udyam Registration", value: BUSINESS.udyam, note: "Ministry of MSME, Government of India", testid: "credential-udyam" },
];

export const Credentials = () => {
  const { openEnquiry } = useEnquiry();

  return (
    <section id="credentials" className="py-16 px-4 sm:px-6 max-w-7xl mx-auto" data-testid="credentials-section">
      <Reveal>
        <div className="border border-spice-line rounded-xl p-6 sm:p-8 bg-white space-y-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-spice-line pb-6">
            <div>
              <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Statutory credentials</span>
              <h2 className="text-xl font-bold text-spice-ink">Business Registration Details</h2>
            </div>
            <div className="text-xs text-spice-subtle">Sole Proprietorship • Hyderabad, Telangana</div>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 text-xs">
            {CREDENTIALS.map((cred) => (
              <div key={cred.testid} className="p-4 bg-spice-cream rounded border border-spice-line space-y-1" data-testid={cred.testid}>
                <span className="text-spice-subtle block">{cred.label}</span>
                <span className="font-bold text-spice-ink text-sm block break-all">{cred.value}</span>
                <span className="text-spice-muted">{cred.note}</span>
              </div>
            ))}
          </div>

          <div className="pt-5 border-t border-spice-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-spice-muted max-w-xl">
              Actual-lot samples or lot photographs are available for buyer verification before any commercial
              commitment. Buyers may verify our registration numbers independently on the relevant government portals.
            </p>
            <div className="flex flex-wrap gap-3 shrink-0">
              <button
                type="button"
                onClick={() =>
                  openEnquiry({ enquiryType: "Actual-Lot Sample", source: "credentials", product: "" })
                }
                data-testid="sample-request-button"
                className="inline-flex items-center justify-center px-5 py-2.5 bg-spice-green text-white text-xs font-bold rounded-[9px] hover:bg-spice-green-dark transition-colors"
              >
                Request Actual-Lot Sample
              </button>
              <a
                href={SAMPLE_WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Request an actual-lot sample on WhatsApp (opens WhatsApp in a new tab)"
                onClick={() => track(EVENTS.sampleRequestClick, { source: "credentials-whatsapp" })}
                data-testid="sample-whatsapp-button"
                className="inline-flex items-center gap-1.5 justify-center px-5 py-2.5 border border-spice-line text-spice-green text-xs font-semibold rounded-[9px] hover:bg-spice-sand transition-colors"
              >
                <MessageCircle className="w-3.5 h-3.5" aria-hidden="true" />
                Sample on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
